import { api } from '@/utils/api'

export interface HookPattern {
  pattern: string
  example: string
}

export interface AngleMap {
  angle: string
  representative: string
}

export interface RhetoricalDevice {
  device: string
  examples: string[]
}

export interface CulturalTrendCues {
  seasons_events: string[]
  memes_challenges: string[]
  named_entities: string[]
  time_urgency_markers: string[]
}

export interface RiskPolicyFlag {
  flag: string
  severity: string
  evidence: string
  safe_rewrite: string
}

export interface TrendListItem {
  trend_id: string
  created_at: number
  mean_residual_like: number
  mean_velocity_comment: number
  mean_velocity_like: number
  median_age: number
  median_engagement_rate: number
  post_count: number
  reach: number
  user_count: number
  word_representation: string[]
  
  // Content analysis fields
  description_text?: string
  hook_patterns?: HookPattern[]
  angle_map?: AngleMap[]
  rhetorical_devices?: RhetoricalDevice[]
  style_cadence_norms?: string
  cultural_trend_cues?: CulturalTrendCues
  risk_policy_flags?: RiskPolicyFlag[]
}

export interface TrendAnalysisResponse {
  success: boolean
  total_trends: number
  trends: TrendListItem[]
  message?: string
}

export interface ListTrendsParams {
  limit?: number
  min_trend_score?: number
  max_trend_rank?: number
}

export const trendsService = {
  async listTrends(params: ListTrendsParams = {}): Promise<TrendAnalysisResponse> {
    const searchParams = new URLSearchParams()
    if (params.limit !== undefined) searchParams.set('limit', String(params.limit))
    if (params.min_trend_score !== undefined) searchParams.set('min_trend_score', String(params.min_trend_score))
    if (params.max_trend_rank !== undefined) searchParams.set('max_trend_rank', String(params.max_trend_rank))

    const query = searchParams.toString()
    const path = query
      ? `/v0_1/trends/instagram/global?${query}`
      : `/v0_1/trends/instagram/global`

    return api.get(path)
  },
} 